import { render, staticRenderFns } from "./StickerPreview.vue?vue&type=template&id=3a6f87be&scoped=true&"
import script from "./StickerPreview.vue?vue&type=script&lang=js&"
export * from "./StickerPreview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a6f87be",
  null
  
)

export default component.exports